import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n/LanguageProvider";
import { SmoothScroll } from "./components/site/SmoothScroll";
import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { TrustMarquee } from "./components/site/TrustMarquee";
import { Services } from "./components/site/Services";
import { WhyUs } from "./components/site/WhyUs";
import { Destinations } from "./components/site/Destinations";
import { HadjjUmrah } from "./components/site/HadjjUmrah";
import { BookingEngine } from "./components/site/BookingEngine";
import { QuickBooking } from "./components/site/QuickBooking";
import { Testimonials } from "./components/site/Testimonials";
import { FinalCTA } from "./components/site/FinalCTA";
import { Footer } from "./components/site/Footer";
import { WhatsAppFloat } from "./components/site/WhatsAppFloat";
import { BookingSuccess } from "./components/site/BookingSuccess";
import { BookingPage } from "./components/site/BookingPage";

const Landing = () => (
  <>
    <Header />
    <main>
      <Hero />
      <TrustMarquee />
      <Services />
      <WhyUs />
      <Destinations />
      <HadjjUmrah />
      <BookingEngine />
      <QuickBooking />
      <Testimonials />
      <FinalCTA />
    </main>
    <Footer />
    <WhatsAppFloat />
  </>
);

function App() {
  return (
    <LanguageProvider>
      <SmoothScroll>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/book" element={<BookingPage />} />
              <Route path="/booking/success" element={<BookingSuccess />} />
            </Routes>
          </BrowserRouter>
          <Toaster
            position="bottom-left"
            toastOptions={{
              style: {
                background: "#0B1416",
                color: "#F5F1E8",
                border: "1px solid rgba(245,241,232,0.15)",
                borderRadius: 4,
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
        </div>
      </SmoothScroll>
    </LanguageProvider>
  );
}

export default App;
